<div class="reduce-risk-container text-center">
	<div class="reduce-risk-bottom">
		<img
			class="reduce-risk-image"
			src="../../assets/img/staying-continuously-compliant.svg"
			alt=""
		/>
		<h2 class="mb-5 reduce-risk-header">
			Staying Continuously Compliant <br class="d-none d-sm-block" />
			Has Never Been Easier
		</h2>
		<p class="reduce-risk-content">
			Regulatory requirements are complex and difficult to manage, yet
			you’re <br class="d-none d-sm-block" />
			expected to sustain cyber security performance, drive effective
			risk<br class="d-none d-sm-block" />
			management, and deliver results-based outcomes. We ensure your
			organization<br class="d-none d-sm-block" />
			stays compliant with the NERC’s Critical Infrastructure Protection
			(CIP)<br class="d-none d-sm-block" />
			requirements as well as all additional standards and requirements
			(e.g. ISO <br class="d-none d-sm-block" />
			27001) for the energy sector. 
		</p>
		<a href="https://go.regscale.com/RegScale-Create-Account">
			<button class="free-trial-btn px-5 py-2 mt-5">Find Out How</button>
		</a>
	</div>

	<div
		class="
			container
			government-hero-middle
			d-flex
			flex-column flex-lg-row
			align-items-center
			justify-content-center
		"
	>
		<img
			class="change-left"
			src="../../assets/img/flexible-financing.svg"
			alt=""
		/>

		<div class="change-right">
			<div class="text-gradient">Flexible Financing for OPEX Budgets</div>
			<div class="my-3 my-lg-4 solution-underline"></div>
			<p>
				Get access to the most secure, trusted
				<br class="d-none d-md-block" />
				compliance platform on the market through an
				<br class="d-none d-md-block" />
				array of capital purchasing options to meet the
				<br class="d-none d-md-block" />
				unique needs of the Energy sector.
			</p>
		</div>
	</div>

	<div class="container">
		<h3 class="regscale-solution-header">
			Nearly 50% of the costs of implementing
			<br class="d-none d-md-block" />
			NERC CIP are related to "paperwork" and don’t
			<br class="d-none d-md-block" />
			directly or materially contribute to cyber<br
				class="d-none d-md-block"
			/>
			security improvements.
		</h3>

		<p>Focus your energy where it matters.</p>
	</div>
</div>
